/**
 * Serviço para gerenciar a conexão com WhatsApp
 */

/**
 * Formata o número de telefone para o padrão internacional brasileiro: 5511987654321
 * @param {string} phoneNumber - Número de telefone do usuário
 * @returns {string} - Número formatado
 */
const formatPhoneNumber = (phoneNumber) => {
  // Remove todos os caracteres não numéricos
  const numbers = phoneNumber.replace(/\D/g, '');
  
  // Se o número já começa com 55, retorna como está
  if (numbers.startsWith('55')) {
    return numbers;
  }
  
  // Adiciona o prefixo 55 (Brasil) no início do número
  return '55' + numbers;
};

const whatsappService = {
  /**
   * Verifica o status da conexão do WhatsApp
   * @param {string} phoneNumber - Número de telefone do usuário
   * @returns {Promise<Object>} - Objeto com status da conexão e QR code se necessário
   */
  checkConnectionStatus: async (phoneNumber) => {
    try {
      const formattedPhone = formatPhoneNumber(phoneNumber);
      
      const response = await fetch('https://webhook-editor.abianca.com.br/webhook/escaneia-qrcode', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          nome_da_instancia: formattedPhone
        })
      });

      const responseText = await response.text();
      
      // Verifica se a resposta é "Conexão Ativa"
      if (responseText === 'Conexão Ativa') {
        return {
          status: 'connected',
          qrCode: null
        };
      }
      
      // Tenta processar a resposta como JSON ou string
      try {
        // Tenta processar como JSON primeiro
        const data = JSON.parse(responseText);
        
        // Verifica se é uma string ou um objeto
        if (typeof data === 'string') {
          return {
            status: 'pending',
            qrCode: data
          };
        } else if (data && typeof data === 'object') {
          // Se for um objeto, pega a primeira chave como QR code
          const qrCodeString = Object.keys(data)[0];
          if (qrCodeString) {
            return {
              status: 'pending',
              qrCode: qrCodeString
            };
          }
        }
        
        // Se chegou aqui, formato desconhecido
        throw new Error('Formato de resposta inválido');
      } catch (jsonError) {
        // Se não for JSON, trata como string direta
        return {
          status: 'pending',
          qrCode: responseText
        };
      }
    } catch (error) {
      console.error('Erro ao verificar status da conexão WhatsApp:', error);
      throw error;
    }
  }
};

export default whatsappService;
